import React from 'react';
import { Row, Col, Typography, Input, DatePicker } from 'antd';

const { Text } = Typography;

export default function DateFields({ values, setFieldValue, showPeriod = true, showDocuments = true }) {
    return (
        <>
            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <Text strong>Due Date</Text>
                    <DatePicker
                        value={values.dueDate}
                        onChange={(v) => setFieldValue('dueDate', v)}
                        style={{ width: '100%', marginTop: 4 }}
                        format="DD MMMM YYYY"
                    />
                </Col>

                {showDocuments && (
                    <>
                        <Col xs={24} md={12}>
                            <Text strong>Nomor Dokumen</Text>
                            <Input
                                name="documentNumber"
                                value={values.documentNumber || ''}
                                onChange={(e) => setFieldValue('documentNumber', e.target.value)}
                                style={{ marginTop: 4 }}
                            />
                        </Col>

                        <Col xs={24} md={12}>
                            <Text strong>Tanggal Dokumen</Text>
                            <DatePicker
                                value={values.documentDate}
                                onChange={(v) => setFieldValue('documentDate', v)}
                                style={{ width: '100%', marginTop: 4 }}
                                format="DD MMMM YYYY"
                            />
                        </Col>
                    </>
                )}

                {showPeriod && (
                    <>
                        <Col xs={24} md={12}>
                            <Text strong>Periode Penyimpanan (Start)</Text>
                            <DatePicker
                                value={values.periodStart}
                                onChange={(v) => setFieldValue('periodStart', v)}
                                style={{ width: '100%', marginTop: 4 }}
                                format="DD MMMM YYYY"
                            />
                        </Col>

                        <Col xs={24} md={12}>
                            <Text strong>Periode Penyimpanan (End)</Text>
                            <DatePicker
                                value={values.periodEnd}
                                onChange={(v) => setFieldValue('periodEnd', v)}
                                style={{ width: '100%', marginTop: 4 }}
                                format="DD MMMM YYYY"
                            />
                        </Col>
                    </>
                )}
            </Row >
        </>
    );
}
